import { render } from "./TeamBuildingView.vue?vue&type=template&id=5d596ab4&scoped=true"
import script from "./TeamBuildingView.vue?vue&type=script&lang=js"
export * from "./TeamBuildingView.vue?vue&type=script&lang=js"

import "./TeamBuildingView.vue?vue&type=style&index=0&id=5d596ab4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d596ab4"]])

export default __exports__